import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface CalendarHeaderConfig {
  hideBtnClear: boolean,
  hideBtnToday: boolean
}

@Injectable({
  providedIn: 'root'
})
export class CalendarService {
  private _calendarHeaderConfig = new BehaviorSubject<CalendarHeaderConfig>({ hideBtnClear: false, hideBtnToday: false })
  public calendarConfig = this._calendarHeaderConfig.value;

  constructor() {}

  public setHeaderConfig(config: CalendarHeaderConfig) {
    this._calendarHeaderConfig.next(config);
  }

  public getHeaderConfig$() {
    return this._calendarHeaderConfig.asObservable();
  }
}
